module.exports = __webpack_public_path__ + "projects.4d84447b.webp";